import { BudgetClassificationTypeEnum } from './constants';

export const GROUND_UP_CATEGORIES = {
    uses: [
        {
            id: 1,
            proFormaId: 0,
            nodeId: 1,
            nodeName: 'Acquisition Costs',
            description: 'Acquisition Costs',
            path: '1',
            children: [
                {
                    id: 2,
                    proFormaId: 0,
                    nodeId: 2,
                    nodeName: 'Acquisition',
                    description: 'Acquisition',
                    path: '1.2',
                    children: [
                        {
                            id: 3,
                            proFormaId: 0,
                            nodeId: 3,
                            nodeName: 'Acquisition Fees - Miscellaneous',
                            budgetLineNickname: 'Acquisition Fees - Miscellaneous',
                            path: '1.2.3',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 4,
                            proFormaId: 0,
                            nodeId: 4,
                            nodeName: 'Acquisition Loan - Interest',
                            budgetLineNickname: 'Acquisition Loan - Interest',
                            path: '1.2.4',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 5,
                            proFormaId: 0,
                            nodeId: 5,
                            nodeName: 'Acquisition Loan - Lender Administrative Fees',
                            budgetLineNickname: 'Acquisition Loan - Lender Administrative Fees',
                            path: '1.2.5',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 6,
                            proFormaId: 0,
                            nodeId: 6,
                            nodeName: 'Acquisition Loan - Miscellaneous Fees',
                            budgetLineNickname: 'Acquisition Loan - Miscellaneous Fees',
                            path: '1.2.6',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 7,
                            proFormaId: 0,
                            nodeId: 7,
                            nodeName: 'Acquisition Loan - Mortgage Broker Fee',
                            budgetLineNickname: 'Acquisition Loan - Mortgage Broker Fee',
                            path: '1.2.7',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 8,
                            proFormaId: 0,
                            nodeId: 8,
                            nodeName: 'Acquisition Loan - Mortgage Recording Tax',
                            budgetLineNickname: 'Acquisition Loan - Mortgage Recording Tax',
                            path: '1.2.8',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 9,
                            proFormaId: 0,
                            nodeId: 9,
                            nodeName: 'Acquisition Loan - Origination Fee',
                            budgetLineNickname: 'Acquisition Loan - Origination Fee',
                            path: '1.2.9',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 10,
                            proFormaId: 0,
                            nodeId: 10,
                            nodeName: 'Acquisition Loan - Title Fees',
                            budgetLineNickname: 'Acquisition Loan - Title Fees',
                            path: '1.2.10',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 11,
                            proFormaId: 0,
                            nodeId: 11,
                            nodeName: 'Purchase Price',
                            budgetLineNickname: 'Purchase Price',
                            path: '1.2.11',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 12,
                            proFormaId: 0,
                            nodeId: 12,
                            nodeName: 'Acquisition Due Diligence',
                            budgetLineNickname: 'Acquisition Due Diligence',
                            path: '1.2.12',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 100,
            proFormaId: 0,
            nodeId: 100,
            nodeName: 'Hard Costs',
            description: 'Hard Costs',
            path: '100',
            children: [
                {
                    id: 101,
                    proFormaId: 0,
                    nodeId: 101,
                    nodeName: 'Construction Manager',
                    description: 'Construction Manager',
                    path: '100.101',
                    children: [
                        {
                            id: 102,
                            proFormaId: 0,
                            nodeId: 102,
                            nodeName: 'Construction Manager (Overall including subcontractors)',
                            budgetLineNickname: 'Construction Manager (Overall including subcontractors)',
                            path: '100.101.102',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 103,
                            proFormaId: 0,
                            nodeId: 103,
                            nodeName: 'Contractor Contingency',
                            budgetLineNickname: 'Contractor Contingency',
                            path: '100.101.103',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 104,
                            proFormaId: 0,
                            nodeId: 104,
                            nodeName: 'GC Insurance - Miscellaneous',
                            budgetLineNickname: 'GC Insurance - Miscellaneous',
                            path: '100.101.104',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 105,
                            proFormaId: 0,
                            nodeId: 105,
                            nodeName: 'General Contractor Fee',
                            budgetLineNickname: 'General Contractor Fee',
                            path: '100.101.105',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 106,
                            proFormaId: 0,
                            nodeId: 106,
                            nodeName: 'General Requirements',
                            budgetLineNickname: 'General Requirements',
                            path: '100.101.106',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 107,
                            proFormaId: 0,
                            nodeId: 107,
                            nodeName: 'Pre-Construction Fees',
                            budgetLineNickname: 'Pre-Construction Fees',
                            path: '100.101.107',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 108,
                    proFormaId: 0,
                    nodeId: 108,
                    nodeName: 'Owner Furnished',
                    description: 'Owner Furnished',
                    path: '100.108',
                    children: [
                        {
                            id: 109,
                            proFormaId: 0,
                            nodeId: 109,
                            nodeName: 'Earthwork',
                            budgetLineNickname: 'Earthwork',
                            path: '100.108.109',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 110,
                            proFormaId: 0,
                            nodeId: 110,
                            nodeName: 'Existing Conditions',
                            budgetLineNickname: 'Existing Conditions',
                            path: '100.108.110',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 111,
                            proFormaId: 0,
                            nodeId: 111,
                            nodeName: 'Furnishings',
                            budgetLineNickname: 'Furnishings',
                            path: '100.108.111',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 112,
                            proFormaId: 0,
                            nodeId: 112,
                            nodeName: 'Signage - Permanent',
                            budgetLineNickname: 'Signage - Permanent',
                            path: '100.108.112',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 113,
                            proFormaId: 0,
                            nodeId: 113,
                            nodeName: 'Tenant Improvement Allowance',
                            budgetLineNickname: 'Tenant Improvement Allowance',
                            path: '100.108.113',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 114,
                            proFormaId: 0,
                            nodeId: 114,
                            nodeName: 'Utility Connection Charges',
                            budgetLineNickname: 'Utility Connection Charges',
                            path: '100.108.114',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 115,
                    proFormaId: 0,
                    nodeId: 115,
                    nodeName: 'Owner Controlled Contingency',
                    description: 'Owner Controlled Contingency',
                    path: '100.115',
                    children: [
                        {
                            id: 116,
                            proFormaId: 0,
                            nodeId: 116,
                            nodeName: 'Allowances',
                            budgetLineNickname: 'Allowances',
                            path: '100.115.116',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 117,
                            proFormaId: 0,
                            nodeId: 117,
                            nodeName: 'Furniture, Fixtures, and Equipment Contingency',
                            budgetLineNickname: 'Furniture, Fixtures, and Equipment Contingency',
                            path: '100.115.117',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 118,
                            proFormaId: 0,
                            nodeId: 118,
                            nodeName: 'Owner Controlled Contingency',
                            budgetLineNickname: 'Owner Controlled Contingency',
                            path: '100.115.118',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 200,
            proFormaId: 0,
            nodeId: 200,
            nodeName: 'Soft Costs',
            description: 'Soft Costs',
            path: '200',
            children: [
                {
                    id: 201,
                    proFormaId: 0,
                    nodeId: 201,
                    nodeName: 'General Administrative & Overhead',
                    description: 'General Administrative & Overhead',
                    path: '200.201',
                    children: [
                        {
                            id: 202,
                            proFormaId: 0,
                            nodeId: 202,
                            nodeName: 'Accounting and Audits',
                            budgetLineNickname: 'Accounting and Audits',
                            path: '200.201.202',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 203,
                            proFormaId: 0,
                            nodeId: 203,
                            nodeName: 'Brokerage',
                            budgetLineNickname: 'Brokerage',
                            path: '200.201.203',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 204,
                            proFormaId: 0,
                            nodeId: 204,
                            nodeName: 'Building Permits',
                            budgetLineNickname: 'Building Permits',
                            path: '200.201.204',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 205,
                            proFormaId: 0,
                            nodeId: 205,
                            nodeName: 'Developer Fee',
                            budgetLineNickname: 'Developer Fee',
                            path: '200.201.205',
                            isDeletable: false,
                            classificationType: BudgetClassificationTypeEnum.DEVELOPER_FEE,
                            isCalculated: false,
                        },
                        {
                            id: 206,
                            proFormaId: 0,
                            nodeId: 206,
                            nodeName: 'General Administration',
                            budgetLineNickname: 'General Administration',
                            path: '200.201.206',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 207,
                            proFormaId: 0,
                            nodeId: 207,
                            nodeName: 'Operating Deficit',
                            budgetLineNickname: 'Operating Deficit',
                            path: '200.201.207',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 208,
                            proFormaId: 0,
                            nodeId: 208,
                            nodeName: 'Project Management',
                            budgetLineNickname: 'Project Management',
                            path: '200.201.208',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 209,
                            proFormaId: 0,
                            nodeId: 209,
                            nodeName: 'Project Software and Applications',
                            budgetLineNickname: 'Project Software and Applications',
                            path: '200.201.209',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 210,
                            proFormaId: 0,
                            nodeId: 210,
                            nodeName: 'Site Security and Maintenance',
                            budgetLineNickname: 'Site Security and Maintenance',
                            path: '200.201.210',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 211,
                            proFormaId: 0,
                            nodeId: 211,
                            nodeName: 'Sponsor Reimbursables',
                            budgetLineNickname: 'Sponsor Reimbursables',
                            path: '200.201.211',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 212,
                            proFormaId: 0,
                            nodeId: 212,
                            nodeName: 'Utilities',
                            budgetLineNickname: 'Utilities',
                            path: '200.201.212',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 213,
                    proFormaId: 0,
                    nodeId: 213,
                    nodeName: 'Insurance, Utilities, Taxes & Other',
                    description: 'Insurance, Utilities, Taxes & Other',
                    path: '200.213',
                    children: [
                        {
                            id: 214,
                            proFormaId: 0,
                            nodeId: 214,
                            nodeName: 'Bond and Insurance',
                            budgetLineNickname: 'Bond and Insurance',
                            path: '200.213.214',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 215,
                            proFormaId: 0,
                            nodeId: 215,
                            nodeName: 'General Liability Insurance',
                            budgetLineNickname: 'General Liability Insurance',
                            path: '200.213.215',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 216,
                            proFormaId: 0,
                            nodeId: 216,
                            nodeName: 'Insurance - Miscellaneous',
                            budgetLineNickname: 'Insurance - Miscellaneous',
                            path: '200.213.216',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 217,
                            proFormaId: 0,
                            nodeId: 217,
                            nodeName: 'Licenses and Operating Permits',
                            budgetLineNickname: 'Licenses and Operating Permits',
                            path: '200.213.217',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 218,
                            proFormaId: 0,
                            nodeId: 218,
                            nodeName: 'Real Estate Taxes',
                            budgetLineNickname: 'Real Estate Taxes',
                            path: '200.213.218',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 219,
                            proFormaId: 0,
                            nodeId: 219,
                            nodeName: 'Title Insurance',
                            budgetLineNickname: 'Title Insurance',
                            path: '200.213.219',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 220,
                    proFormaId: 0,
                    nodeId: 220,
                    nodeName: 'Architecture, Engineering, & Design',
                    description: 'Architecture, Engineering, & Design',
                    path: '200.220',
                    children: [
                        {
                            id: 221,
                            proFormaId: 0,
                            nodeId: 221,
                            nodeName: 'Civil Engineer',
                            budgetLineNickname: 'Civil Engineer',
                            path: '200.220.221',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 222,
                            proFormaId: 0,
                            nodeId: 222,
                            nodeName: 'Consultant Reimbursables',
                            budgetLineNickname: 'Consultant Reimbursables',
                            path: '200.220.222',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 223,
                            proFormaId: 0,
                            nodeId: 223,
                            nodeName: 'Geotechnical Design and Engineering',
                            budgetLineNickname: 'Geotechnical Design and Engineering',
                            path: '200.220.223',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 224,
                            proFormaId: 0,
                            nodeId: 224,
                            nodeName: 'Interior Designer',
                            budgetLineNickname: 'Interior Designer',
                            path: '200.220.224',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 225,
                            proFormaId: 0,
                            nodeId: 225,
                            nodeName: 'Landscape Architect',
                            budgetLineNickname: 'Landscape Architect',
                            path: '200.220.225',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 226,
                            proFormaId: 0,
                            nodeId: 226,
                            nodeName: 'Lighting Designer',
                            budgetLineNickname: 'Lighting Designer',
                            path: '200.220.226',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 227,
                            proFormaId: 0,
                            nodeId: 227,
                            nodeName: 'MEP Engineer',
                            budgetLineNickname: 'MEP Engineer',
                            path: '200.220.227',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 228,
                            proFormaId: 0,
                            nodeId: 228,
                            nodeName: 'Project Architect',
                            budgetLineNickname: 'Project Architect',
                            path: '200.220.228',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 229,
                            proFormaId: 0,
                            nodeId: 229,
                            nodeName: 'Structural Engineer',
                            budgetLineNickname: 'Structural Engineer',
                            path: '200.220.229',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 230,
                    proFormaId: 0,
                    nodeId: 230,
                    nodeName: 'Other Consultants',
                    description: 'Other Consultants',
                    path: '200.230',
                    children: [
                        {
                            id: 231,
                            proFormaId: 0,
                            nodeId: 231,
                            nodeName: 'Abatement Consultant',
                            budgetLineNickname: 'Abatement Consultant',
                            path: '200.230.231',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 232,
                            proFormaId: 0,
                            nodeId: 232,
                            nodeName: 'Accessibility Consultant',
                            budgetLineNickname: 'Accessibility Consultant',
                            path: '200.230.232',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 233,
                            proFormaId: 0,
                            nodeId: 233,
                            nodeName: 'Acoustics Consultant',
                            budgetLineNickname: 'Acoustics Consultant',
                            path: '200.230.233',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 234,
                            proFormaId: 0,
                            nodeId: 234,
                            nodeName: 'Audio Visual Consultant',
                            budgetLineNickname: 'Audio Visual Consultant',
                            path: '200.230.234',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 235,
                            proFormaId: 0,
                            nodeId: 235,
                            nodeName: 'Commissioning Consultant',
                            budgetLineNickname: 'Commissioning Consultant',
                            path: '200.230.235',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 236,
                            proFormaId: 0,
                            nodeId: 236,
                            nodeName: 'Envelop and Cladding Consultant',
                            budgetLineNickname: 'Envelop and Cladding Consultant',
                            path: '200.230.236',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 237,
                            proFormaId: 0,
                            nodeId: 237,
                            nodeName: 'Environmental Consultant',
                            budgetLineNickname: 'Environmental Consultant',
                            path: '200.230.237',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 238,
                            proFormaId: 0,
                            nodeId: 238,
                            nodeName: 'Fire and Life Safety Consultant',
                            budgetLineNickname: 'Fire and Life Safety Consultant',
                            path: '200.230.238',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 239,
                            proFormaId: 0,
                            nodeId: 239,
                            nodeName: 'IT Consultant',
                            budgetLineNickname: 'IT Consultant',
                            path: '200.230.239',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 240,
                            proFormaId: 0,
                            nodeId: 240,
                            nodeName: 'Security Consultant',
                            budgetLineNickname: 'Security Consultant',
                            path: '200.230.240',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 241,
                            proFormaId: 0,
                            nodeId: 241,
                            nodeName: 'Signage and Wayfinding Consultant',
                            budgetLineNickname: 'Signage and Wayfinding Consultant',
                            path: '200.230.241',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 242,
                            proFormaId: 0,
                            nodeId: 242,
                            nodeName: 'Surveyor',
                            budgetLineNickname: 'Surveyor',
                            path: '200.230.242',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 243,
                            proFormaId: 0,
                            nodeId: 243,
                            nodeName: 'Sustainability Consultant',
                            budgetLineNickname: 'Sustainability Consultant',
                            path: '200.230.243',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 244,
                            proFormaId: 0,
                            nodeId: 244,
                            nodeName: 'Transportation and Traffic Consultant',
                            budgetLineNickname: 'Transportation and Traffic Consultant',
                            path: '200.230.244',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 245,
                            proFormaId: 0,
                            nodeId: 245,
                            nodeName: 'Utilities Consultant',
                            budgetLineNickname: 'Utilities Consultant',
                            path: '200.230.245',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 246,
                            proFormaId: 0,
                            nodeId: 246,
                            nodeName: 'Vertical Transportation Consultant',
                            budgetLineNickname: 'Vertical Transportation Consultant',
                            path: '200.230.246',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 247,
                            proFormaId: 0,
                            nodeId: 247,
                            nodeName: 'Waterproofing Consultant',
                            budgetLineNickname: 'Waterproofing Consultant',
                            path: '200.230.247',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 250,
                    proFormaId: 0,
                    nodeId: 250,
                    nodeName: 'Expediting, Inspections & Approvals',
                    description: 'Expediting, Inspections & Approvals',
                    path: '200.250',
                    children: [
                        {
                            id: 251,
                            proFormaId: 0,
                            nodeId: 251,
                            nodeName: 'Construction Surveys and Monitoring',
                            budgetLineNickname: 'Construction Surveys and Monitoring',
                            path: '200.250.251',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 252,
                            proFormaId: 0,
                            nodeId: 252,
                            nodeName: 'Entitlements Consultant',
                            budgetLineNickname: 'Entitlements Consultant',
                            path: '200.250.252',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 253,
                            proFormaId: 0,
                            nodeId: 253,
                            nodeName: 'Environmental Testing',
                            budgetLineNickname: 'Environmental Testing',
                            path: '200.250.253',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 254,
                            proFormaId: 0,
                            nodeId: 254,
                            nodeName: 'Expeditor and Code Consultant',
                            budgetLineNickname: 'Expeditor and Code Consultant',
                            path: '200.250.254',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 255,
                            proFormaId: 0,
                            nodeId: 255,
                            nodeName: 'Impact Review and Mitigation Fees',
                            budgetLineNickname: 'Impact Review and Mitigation Fees',
                            path: '200.250.255',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 256,
                            proFormaId: 0,
                            nodeId: 256,
                            nodeName: 'Lender Inspection Fees',
                            budgetLineNickname: 'Lender Inspection Fees',
                            path: '200.250.256',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 257,
                            proFormaId: 0,
                            nodeId: 257,
                            nodeName: 'Materials Testing',
                            budgetLineNickname: 'Materials Testing',
                            path: '200.250.257',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 258,
                            proFormaId: 0,
                            nodeId: 258,
                            nodeName: 'Permits and Fees - Miscellaneous',
                            budgetLineNickname: 'Permits and Fees - Miscellaneous',
                            path: '200.250.258',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 259,
                            proFormaId: 0,
                            nodeId: 259,
                            nodeName: 'Special and Controlled Inspections',
                            budgetLineNickname: 'Special and Controlled Inspections',
                            path: '200.250.259',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 260,
                    proFormaId: 0,
                    nodeId: 260,
                    nodeName: 'Legal Services',
                    description: 'Legal Services',
                    path: '200.260',
                    children: [
                        {
                            id: 261,
                            proFormaId: 0,
                            nodeId: 261,
                            nodeName: 'Entity, Formation, and Organizational Costs',
                            budgetLineNickname: 'Entity, Formation, and Organizational Costs',
                            path: '200.260.261',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 262,
                            proFormaId: 0,
                            nodeId: 262,
                            nodeName: 'Legal Services',
                            budgetLineNickname: 'Legal Services',
                            path: '200.260.262',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 263,
                            proFormaId: 0,
                            nodeId: 263,
                            nodeName: 'Land Use and Zoning',
                            budgetLineNickname: 'Land Use and Zoning',
                            path: '200.260.263',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 290,
                    proFormaId: 0,
                    nodeId: 290,
                    nodeName: 'Contingency',
                    description: 'Contingency',
                    path: '200.290',
                    children: [
                        {
                            id: 291,
                            proFormaId: 0,
                            nodeId: 291,
                            nodeName: 'Soft Cost Contingency',
                            budgetLineNickname: 'Soft Cost Contingency',
                            path: '200.290.291',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 300,
                    proFormaId: 0,
                    nodeId: 300,
                    nodeName: 'Marketing',
                    description: 'Marketing',
                    path: '200.300',
                    children: [
                        {
                            id: 301,
                            proFormaId: 0,
                            nodeId: 301,
                            nodeName: 'Marketing (general)',
                            budgetLineNickname: 'Marketing (general)',
                            path: '200.300.301',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 302,
                            proFormaId: 0,
                            nodeId: 302,
                            nodeName: 'Digital Marketing',
                            budgetLineNickname: 'Digital Marketing',
                            path: '200.300.302',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 303,
                            proFormaId: 0,
                            nodeId: 303,
                            nodeName: 'Public Relations',
                            budgetLineNickname: 'Public Relations',
                            path: '200.300.303',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 3400,
            proFormaId: 0,
            nodeId: 3400,
            nodeName: 'Soft Costs',
            description: 'Financing Costs',
            path: '3401',
            children: [{
                id: 34019,
                proFormaId: 0,
                nodeId: 34019,
                nodeName: 'Financing Costs',
                description: 'Financing Costs',
                path: '3400.34019',
                children: [
                    {
                        id: 3401,
                        proFormaId: 0,
                        nodeId: 3401,
                        nodeName: 'Carry Costs - Miscellaneous',
                        budgetLineNickname: 'Carry Costs - Miscellaneous',
                        path: '3400.34019.3401',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3402,
                        proFormaId: 0,
                        nodeId: 3402,
                        nodeName: 'Construction Loan - Commitment Fee',
                        budgetLineNickname: 'Construction Loan - Commitment Fee',
                        path: '3400.34019.3402',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3403,
                        proFormaId: 0,
                        nodeId: 3403,
                        nodeName: 'Construction Loan - Holdback',
                        budgetLineNickname: 'Construction Loan - Holdback',
                        path: '3400.34019.3403',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3405,
                        proFormaId: 0,
                        nodeId: 3405,
                        nodeName: 'Construction Loan - Lender Administrative Fees',
                        budgetLineNickname: 'Construction Loan - Lender Administrative Fees',
                        path: '3400.34019.3405',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3406,
                        proFormaId: 0,
                        nodeId: 3406,
                        nodeName: 'Construction Loan - Miscellaneous Fees',
                        budgetLineNickname: 'Construction Loan - Miscellaneous Fees',
                        path: '3400.34019.3406',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3407,
                        proFormaId: 0,
                        nodeId: 3407,
                        nodeName: 'Construction Loan - Mortgage Broker Fee',
                        budgetLineNickname: 'Construction Loan - Mortgage Broker Fee',
                        path: '3400.34019.3407',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3408,
                        proFormaId: 0,
                        nodeId: 3408,
                        nodeName: 'Construction Loan - Mortgage Recording Tax',
                        budgetLineNickname: 'Construction Loan - Mortgage Recording Tax',
                        path: '3400.34019.3408',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3409,
                        proFormaId: 0,
                        nodeId: 3409,
                        nodeName: 'Construction Loan - Origination Fee',
                        budgetLineNickname: 'Construction Loan - Origination Fee',
                        path: '3400.34019.3409',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3410,
                        proFormaId: 0,
                        nodeId: 3410,
                        nodeName: 'Construction Loan - Title Fees',
                        budgetLineNickname: 'Construction Loan - Title Fees',
                        path: '3400.34019.3410',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3411,
                        proFormaId: 0,
                        nodeId: 3411,
                        nodeName: 'Escrow Fees',
                        budgetLineNickname: 'Escrow Fees',
                        path: '3400.34019.3411',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3412,
                        proFormaId: 0,
                        nodeId: 3412,
                        nodeName: 'Financing Contingency',
                        budgetLineNickname: 'Financing Contingency',
                        path: '3400.34019.3412',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3413,
                        proFormaId: 0,
                        nodeId: 3413,
                        nodeName: 'Financing Fee',
                        budgetLineNickname: 'Financing fee',
                        path: '3400.34019.3413',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.FINANCING_FEE,
                        isCalculated: false,
                    },
                    {
                        id: 3414,
                        proFormaId: 0,
                        nodeId: 3414,
                        nodeName: 'Interest reserve',
                        budgetLineNickname: 'Interest reserve',
                        path: '3400.34019.3414',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.INTEREST_RESERVE,
                        isCalculated: true,
                    },
                ],
            }],
        },
        {
            id: 4400,
            proFormaId: 0,
            nodeId: 4400,
            nodeName: 'Soft Costs',
            description: 'Reserves',
            path: '4400',
            children: [{
                id: 4401,
                proFormaId: 0,
                nodeId: 4401,
                nodeName: 'Reserves',
                description: 'Reserves',
                path: '4400.4401',
                children: [
                    {
                        id: 4402,
                        proFormaId: 0,
                        nodeId: 4402,
                        nodeName: 'Operating Deficit',
                        budgetLineNickname: 'Operating Reserve',
                        path: '4400.4401.4402',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.OPERATING_RESERVE,
                        isCalculated: true,
                    },
                ],
            }],
        },
    ],
    totals: {
        amount: null,
        costPerGrossSquareFootage: null,
        costPerRentableSquareFootage: null,
        costPerLot: null,
        costPerResidentialUnit: null,
        costPerAcre: null,
        costPerMegawatt: null,
        costPerBed: null,
        costPerKilowatt: null,
        costPerRack: null,
    },
    periodsTotals: [],
};

export const MAJOR_RENOVATION_CATEGORIES = {
    uses: [
        {
            id: 1000,
            proFormaId: 0,
            nodeId: 1000,
            nodeName: 'Acquisition Costs',
            description: 'Acquisition Costs',
            path: '1000',
            children: [
                {
                    id: 1001,
                    proFormaId: 0,
                    nodeId: 1001,
                    nodeName: 'Acquisition',
                    description: 'Acquisition',
                    path: '1000.1001',
                    children: [
                        {
                            id: 1002,
                            proFormaId: 0,
                            nodeId: 1002,
                            nodeName: 'Acquisition Fees - Miscellaneous',
                            budgetLineNickname: 'Acquisition Fees - Miscellaneous',
                            path: '1000.1001.1002',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1003,
                            proFormaId: 0,
                            nodeId: 1003,
                            nodeName: 'Acquisition Loan - Interest',
                            budgetLineNickname: 'Acquisition Loan - Interest',
                            path: '1000.1001.1003',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1004,
                            proFormaId: 0,
                            nodeId: 1004,
                            nodeName: 'Acquisition Loan - Lender Administrative Fees',
                            budgetLineNickname: 'Acquisition Loan - Lender Administrative Fees',
                            path: '1000.1001.1004',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1005,
                            proFormaId: 0,
                            nodeId: 1005,
                            nodeName: 'Acquisition Loan - Miscellaneous Fees',
                            budgetLineNickname: 'Acquisition Loan - Miscellaneous Fees',
                            path: '1000.1001.1005',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1006,
                            proFormaId: 0,
                            nodeId: 1006,
                            nodeName: 'Acquisition Loan - Mortgage Broker Fee',
                            budgetLineNickname: 'Acquisition Loan - Mortgage Broker Fee',
                            path: '1000.1001.1006',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1007,
                            proFormaId: 0,
                            nodeId: 1007,
                            nodeName: 'Acquisition Loan - Mortgage Recording Tax',
                            budgetLineNickname: 'Acquisition Loan - Mortgage Recording Tax',
                            path: '1000.1001.1007',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1008,
                            proFormaId: 0,
                            nodeId: 1008,
                            nodeName: 'Acquisition Loan - Origination Fee',
                            budgetLineNickname: 'Acquisition Loan - Origination Fee',
                            path: '1000.1001.1008',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1009,
                            proFormaId: 0,
                            nodeId: 1009,
                            nodeName: 'Acquisition Loan - Title Fees',
                            budgetLineNickname: 'Acquisition Loan - Title Fees',
                            path: '1000.1001.1009',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1010,
                            proFormaId: 0,
                            nodeId: 1010,
                            nodeName: 'Purchase Price',
                            budgetLineNickname: 'Purchase Price',
                            path: '1000.1001.1010',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1011,
                            proFormaId: 0,
                            nodeId: 1011,
                            nodeName: 'Acquisition Due Diligence',
                            budgetLineNickname: 'Acquisition Due Diligence',
                            path: '1000.1001.1011',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 1100,
            proFormaId: 0,
            nodeId: 1100,
            nodeName: 'Hard Costs',
            description: 'Hard Costs',
            path: '1100',
            children: [
                {
                    id: 1101,
                    proFormaId: 0,
                    nodeId: 1101,
                    nodeName: 'Construction Manager',
                    description: 'Construction Manager',
                    path: '1100.1101',
                    children: [
                        {
                            id: 1102,
                            proFormaId: 0,
                            nodeId: 1102,
                            nodeName: 'Construction Manager (Overall including subcontractors)',
                            budgetLineNickname: 'Construction Manager (Overall including subcontractors)',
                            path: '1100.1101.1102',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1103,
                            proFormaId: 0,
                            nodeId: 1103,
                            nodeName: 'Contractor Contingency',
                            budgetLineNickname: 'Contractor Contingency',
                            path: '1100.1101.1103',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1104,
                            proFormaId: 0,
                            nodeId: 1104,
                            nodeName: 'GC Insurance - Miscellaneous',
                            budgetLineNickname: 'GC Insurance - Miscellaneous',
                            path: '1100.1101.1104',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1105,
                            proFormaId: 0,
                            nodeId: 1105,
                            nodeName: 'General Contractor Fee',
                            budgetLineNickname: 'General Contractor Fee',
                            path: '1100.1101.1105',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1106,
                            proFormaId: 0,
                            nodeId: 1106,
                            nodeName: 'General Requirements',
                            budgetLineNickname: 'General Requirements',
                            path: '1100.1101.1106',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1107,
                            proFormaId: 0,
                            nodeId: 1107,
                            nodeName: 'Pre-Construction Fees',
                            budgetLineNickname: 'Pre-Construction Fees',
                            path: '1100.1101.1107',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1108,
                    proFormaId: 0,
                    nodeId: 1108,
                    nodeName: 'Owner Furnished',
                    description: 'Owner Furnished',
                    path: '1100.1108',
                    children: [
                        {
                            id: 1109,
                            proFormaId: 0,
                            nodeId: 1109,
                            nodeName: 'Earthwork',
                            budgetLineNickname: 'Earthwork',
                            path: '1100.1108.1109',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1110,
                            proFormaId: 0,
                            nodeId: 1110,
                            nodeName: 'Existing Conditions',
                            budgetLineNickname: 'Existing Conditions',
                            path: '1100.1108.1110',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1111,
                            proFormaId: 0,
                            nodeId: 1111,
                            nodeName: 'Furnishings',
                            budgetLineNickname: 'Furnishings',
                            path: '1100.1108.1111',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1112,
                            proFormaId: 0,
                            nodeId: 1112,
                            nodeName: 'Signage - Permanent',
                            budgetLineNickname: 'Signage - Permanent',
                            path: '1100.1108.1112',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1113,
                            proFormaId: 0,
                            nodeId: 1113,
                            nodeName: 'Tenant Improvement Allowance',
                            budgetLineNickname: 'Tenant Improvement Allowance',
                            path: '1100.1108.1113',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1114,
                            proFormaId: 0,
                            nodeId: 1114,
                            nodeName: 'Utility Connection Charges',
                            budgetLineNickname: 'Utility Connection Charges',
                            path: '1100.1108.1114',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1115,
                    proFormaId: 0,
                    nodeId: 1115,
                    nodeName: 'Owner Controlled Contingency',
                    description: 'Owner Controlled Contingency',
                    path: '1100.1115',
                    children: [
                        {
                            id: 1116,
                            proFormaId: 0,
                            nodeId: 1116,
                            nodeName: 'Allowances',
                            budgetLineNickname: 'Allowances',
                            path: '1100.1115.1116',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1117,
                            proFormaId: 0,
                            nodeId: 1117,
                            nodeName: 'Furniture, Fixtures, and Equipment Contingency',
                            budgetLineNickname: 'Furniture, Fixtures, and Equipment Contingency',
                            path: '1100.1115.1117',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1118,
                            proFormaId: 0,
                            nodeId: 1118,
                            nodeName: 'Owner Controlled Contingency',
                            budgetLineNickname: 'Owner Controlled Contingency',
                            path: '1100.1115.1118',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 1119,
            proFormaId: 0,
            nodeId: 1119,
            nodeName: 'Soft Costs',
            description: 'Soft Costs',
            path: '1100.1119',
            children: [
                {
                    id: 1120,
                    proFormaId: 0,
                    nodeId: 1120,
                    nodeName: 'General Administrative & Overhead',
                    description: 'General Administrative & Overhead',
                    path: '1100.1119.1120',
                    children: [
                        {
                            id: 1121,
                            proFormaId: 0,
                            nodeId: 1121,
                            nodeName: 'Accounting and Audits',
                            budgetLineNickname: 'Accounting and Audits',
                            path: '1100.1119.1120.1121',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1122,
                            proFormaId: 0,
                            nodeId: 1122,
                            nodeName: 'Brokerage',
                            budgetLineNickname: 'Brokerage',
                            path: '1100.1119.1120.1122',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1123,
                            proFormaId: 0,
                            nodeId: 1123,
                            nodeName: 'Building Permits',
                            budgetLineNickname: 'Building Permits',
                            path: '1100.1119.1120.1123',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1124,
                            proFormaId: 0,
                            nodeId: 1124,
                            nodeName: 'Developer Fee',
                            budgetLineNickname: 'Developer Fee',
                            path: '1100.1119.1120.1124',
                            isDeletable: false,
                            classificationType: BudgetClassificationTypeEnum.DEVELOPER_FEE,
                            isCalculated: false,
                        },
                        {
                            id: 1125,
                            proFormaId: 0,
                            nodeId: 1125,
                            nodeName: 'General Administration',
                            budgetLineNickname: 'General Administration',
                            path: '1100.1119.1120.1125',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1126,
                            proFormaId: 0,
                            nodeId: 1126,
                            nodeName: 'Operating Deficit',
                            budgetLineNickname: 'Operating Deficit',
                            path: '1100.1119.1120.1126',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1127,
                            proFormaId: 0,
                            nodeId: 1127,
                            nodeName: 'Project Management',
                            budgetLineNickname: 'Project Management',
                            path: '1100.1119.1120.1127',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1128,
                            proFormaId: 0,
                            nodeId: 1128,
                            nodeName: 'Project Software and Applications',
                            budgetLineNickname: 'Project Software and Applications',
                            path: '1100.1119.1120.1128',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1129,
                            proFormaId: 0,
                            nodeId: 1129,
                            nodeName: 'Site Security and Maintenance',
                            budgetLineNickname: 'Site Security and Maintenance',
                            path: '1100.1119.1120.1129',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1130,
                            proFormaId: 0,
                            nodeId: 1130,
                            nodeName: 'Sponsor Reimbursables',
                            budgetLineNickname: 'Sponsor Reimbursables',
                            path: '1100.1119.1120.1130',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1131,
                            proFormaId: 0,
                            nodeId: 1131,
                            nodeName: 'Utilities',
                            budgetLineNickname: 'Utilities',
                            path: '1100.1119.1120.1131',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1132,
                    proFormaId: 0,
                    nodeId: 1132,
                    nodeName: 'Insurance, Utilities, Taxes & Other',
                    description: 'Insurance, Utilities, Taxes & Other',
                    path: '1100.1119.1132',
                    children: [
                        {
                            id: 1133,
                            proFormaId: 0,
                            nodeId: 1133,
                            nodeName: 'Bond and Insurance',
                            budgetLineNickname: 'Bond and Insurance',
                            path: '1100.1119.1132.1133',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1134,
                            proFormaId: 0,
                            nodeId: 1134,
                            nodeName: 'General Liability Insurance',
                            budgetLineNickname: 'General Liability Insurance',
                            path: '1100.1119.1132.1134',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1135,
                            proFormaId: 0,
                            nodeId: 1135,
                            nodeName: 'Insurance - Miscellaneous',
                            budgetLineNickname: 'Insurance - Miscellaneous',
                            path: '1100.1119.1132.1135',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1136,
                            proFormaId: 0,
                            nodeId: 1136,
                            nodeName: 'Licenses and Operating Permits',
                            budgetLineNickname: 'Licenses and Operating Permits',
                            path: '1100.1119.1132.1136',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1137,
                            proFormaId: 0,
                            nodeId: 1137,
                            nodeName: 'Real Estate Taxes',
                            budgetLineNickname: 'Real Estate Taxes',
                            path: '1100.1119.1132.1137',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1138,
                            proFormaId: 0,
                            nodeId: 1138,
                            nodeName: 'Title Insurance',
                            budgetLineNickname: 'Title Insurance',
                            path: '1100.1119.1132.1138',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1139,
                    proFormaId: 0,
                    nodeId: 1139,
                    nodeName: 'Architecture, Engineering, & Design',
                    description: 'Architecture, Engineering, & Design',
                    path: '1100.1119.1139',
                    children: [
                        {
                            id: 1140,
                            proFormaId: 0,
                            nodeId: 1140,
                            nodeName: 'Civil Engineer',
                            budgetLineNickname: 'Civil Engineer',
                            path: '1100.1119.1139.1140',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1141,
                            proFormaId: 0,
                            nodeId: 1141,
                            nodeName: 'Consultant Reimbursables',
                            budgetLineNickname: 'Consultant Reimbursables',
                            path: '1100.1119.1139.1141',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1142,
                            proFormaId: 0,
                            nodeId: 1142,
                            nodeName: 'Geotechnical Design and Engineering',
                            budgetLineNickname: 'Geotechnical Design and Engineering',
                            path: '1100.1119.1139.1142',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1143,
                            proFormaId: 0,
                            nodeId: 1143,
                            nodeName: 'Interior Designer',
                            budgetLineNickname: 'Interior Designer',
                            path: '1100.1119.1139.1143',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1144,
                            proFormaId: 0,
                            nodeId: 1144,
                            nodeName: 'Landscape Architect',
                            budgetLineNickname: 'Landscape Architect',
                            path: '1100.1119.1139.1144',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1145,
                            proFormaId: 0,
                            nodeId: 1145,
                            nodeName: 'Lighting Designer',
                            budgetLineNickname: 'Lighting Designer',
                            path: '1100.1119.1139.1145',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1146,
                            proFormaId: 0,
                            nodeId: 1146,
                            nodeName: 'MEP Engineer',
                            budgetLineNickname: 'MEP Engineer',
                            path: '1100.1119.1139.1146',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1147,
                            proFormaId: 0,
                            nodeId: 1147,
                            nodeName: 'Project Architect',
                            budgetLineNickname: 'Project Architect',
                            path: '1100.1119.1139.1147',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1148,
                            proFormaId: 0,
                            nodeId: 1148,
                            nodeName: 'Structural Engineer',
                            budgetLineNickname: 'Structural Engineer',
                            path: '1100.1119.1139.1148',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1149,
                    proFormaId: 0,
                    nodeId: 1149,
                    nodeName: 'Other Consultants',
                    description: 'Other Consultants',
                    path: '1100.1119.1149',
                    children: [
                        {
                            id: 1150,
                            proFormaId: 0,
                            nodeId: 1150,
                            nodeName: 'Abatement Consultant',
                            budgetLineNickname: 'Abatement Consultant',
                            path: '1100.1119.1149.1150',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1151,
                            proFormaId: 0,
                            nodeId: 1151,
                            nodeName: 'Accessibility Consultant',
                            budgetLineNickname: 'Accessibility Consultant',
                            path: '1100.1119.1149.1151',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1152,
                            proFormaId: 0,
                            nodeId: 1152,
                            nodeName: 'Acoustics Consultant',
                            budgetLineNickname: 'Acoustics Consultant',
                            path: '1100.1119.1149.1152',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1153,
                            proFormaId: 0,
                            nodeId: 1153,
                            nodeName: 'Audio Visual Consultant',
                            budgetLineNickname: 'Audio Visual Consultant',
                            path: '1100.1119.1149.1153',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1154,
                            proFormaId: 0,
                            nodeId: 1154,
                            nodeName: 'Commissioning Consultant',
                            budgetLineNickname: 'Commissioning Consultant',
                            path: '1100.1119.1149.1154',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1155,
                            proFormaId: 0,
                            nodeId: 1155,
                            nodeName: 'Envelop and Cladding Consultant',
                            budgetLineNickname: 'Envelop and Cladding Consultant',
                            path: '1100.1119.1149.1155',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1156,
                            proFormaId: 0,
                            nodeId: 1156,
                            nodeName: 'Environmental Consultant',
                            budgetLineNickname: 'Environmental Consultant',
                            path: '1100.1119.1149.1156',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1157,
                            proFormaId: 0,
                            nodeId: 1157,
                            nodeName: 'Fire and Life Safety Consultant',
                            budgetLineNickname: 'Fire and Life Safety Consultant',
                            path: '1100.1119.1149.1157',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1158,
                            proFormaId: 0,
                            nodeId: 1158,
                            nodeName: 'IT Consultant',
                            budgetLineNickname: 'IT Consultant',
                            path: '1100.1119.1149.1158',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1159,
                            proFormaId: 0,
                            nodeId: 1159,
                            nodeName: 'Security Consultant',
                            budgetLineNickname: 'Security Consultant',
                            path: '1100.1119.1149.1159',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1160,
                            proFormaId: 0,
                            nodeId: 1160,
                            nodeName: 'Signage and Wayfinding Consultant',
                            budgetLineNickname: 'Signage and Wayfinding Consultant',
                            path: '1100.1119.1149.1160',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1161,
                            proFormaId: 0,
                            nodeId: 1161,
                            nodeName: 'Surveyor',
                            budgetLineNickname: 'Surveyor',
                            path: '1100.1119.1149.1161',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1162,
                            proFormaId: 0,
                            nodeId: 1162,
                            nodeName: 'Sustainability Consultant',
                            budgetLineNickname: 'Sustainability Consultant',
                            path: '1100.1119.1149.1162',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1163,
                            proFormaId: 0,
                            nodeId: 1163,
                            nodeName: 'Transportation and Traffic Consultant',
                            budgetLineNickname: 'Transportation and Traffic Consultant',
                            path: '1100.1119.1149.1163',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1164,
                            proFormaId: 0,
                            nodeId: 1164,
                            nodeName: 'Utilities Consultant',
                            budgetLineNickname: 'Utilities Consultant',
                            path: '1100.1119.1149.1164',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1165,
                            proFormaId: 0,
                            nodeId: 1165,
                            nodeName: 'Vertical Transportation Consultant',
                            budgetLineNickname: 'Vertical Transportation Consultant',
                            path: '1100.1119.1149.1165',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1166,
                            proFormaId: 0,
                            nodeId: 1166,
                            nodeName: 'Waterproofing Consultant',
                            budgetLineNickname: 'Waterproofing Consultant',
                            path: '1100.1119.1149.1166',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1167,
                    proFormaId: 0,
                    nodeId: 1167,
                    nodeName: 'Expediting, Inspections & Approvals',
                    description: 'Expediting, Inspections & Approvals',
                    path: '1100.1119.1167',
                    children: [
                        {
                            id: 1168,
                            proFormaId: 0,
                            nodeId: 1168,
                            nodeName: 'Construction Surveys and Monitoring',
                            budgetLineNickname: 'Construction Surveys and Monitoring',
                            path: '1100.1119.1167.1168',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1169,
                            proFormaId: 0,
                            nodeId: 1169,
                            nodeName: 'Entitlements Consultant',
                            budgetLineNickname: 'Entitlements Consultant',
                            path: '1100.1119.1167.1169',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 1170,
                            proFormaId: 0,
                            nodeId: 1170,
                            nodeName: 'Environmental Testing',
                            budgetLineNickname: 'Environmental Testing',
                            path: '1100.1119.1167.1170',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1167,
                    proFormaId: 0,
                    nodeId: 1167,
                    nodeName: 'Legal Services',
                    description: 'Legal Services',
                    path: '1100.1119.1167',
                    children: [
                        {
                            id: 2249,
                            proFormaId: 0,
                            nodeId: 2249,
                            nodeName: 'Legal Services',
                            budgetLineNickname: 'Entity, Formation, and Organizational Costs',
                            path: '2200.2248.2250',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2250,
                            proFormaId: 0,
                            nodeId: 2250,
                            nodeName: 'Legal Services',
                            budgetLineNickname: 'Legal Services',
                            path: '2200.2248.2249',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2251,
                            proFormaId: 0,
                            nodeId: 2251,
                            nodeName: 'Legal Services',
                            budgetLineNickname: 'Land Use and Zoning',
                            path: '2200.2248.2251',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1167,
                    proFormaId: 0,
                    nodeId: 1167,
                    nodeName: 'Contingency',
                    description: 'Contingency',
                    path: '1100.1119.1167',
                    children: [
                        {
                            id: 2249,
                            proFormaId: 0,
                            nodeId: 2249,
                            nodeName: 'Soft Cost Contingency',
                            budgetLineNickname: 'Soft Cost Contingency',
                            path: '2200.2248.2250',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 1167,
                    proFormaId: 0,
                    nodeId: 1167,
                    nodeName: 'Marketing',
                    description: 'Marketing',
                    path: '1100.1119.1167',
                    children: [
                        {
                            id: 2249,
                            proFormaId: 0,
                            nodeId: 2249,
                            nodeName: 'Marketing (general)',
                            budgetLineNickname: 'Marketing (general)',
                            path: '2200.2248.2250',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2249,
                            proFormaId: 0,
                            nodeId: 2249,
                            nodeName: 'Digital Marketing',
                            budgetLineNickname: 'Digital Marketing',
                            path: '2200.2248.2250',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2249,
                            proFormaId: 0,
                            nodeId: 2249,
                            nodeName: 'Public Relations',
                            budgetLineNickname: 'Public Relations',
                            path: '2200.2248.2250',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 3400,
            proFormaId: 0,
            nodeId: 3400,
            nodeName: 'Soft Costs',
            description: 'Financing Costs',
            path: '3401',
            children: [{
                id: 34019,
                proFormaId: 0,
                nodeId: 34019,
                nodeName: 'Financing Costs',
                description: 'Financing Costs',
                path: '3400.34019',
                children: [
                    {
                        id: 3401,
                        proFormaId: 0,
                        nodeId: 3401,
                        nodeName: 'Carry Costs - Miscellaneous',
                        budgetLineNickname: 'Carry Costs - Miscellaneous',
                        path: '3400.34019.3401',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3402,
                        proFormaId: 0,
                        nodeId: 3402,
                        nodeName: 'Construction Loan - Commitment Fee',
                        budgetLineNickname: 'Construction Loan - Commitment Fee',
                        path: '3400.34019.3402',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3403,
                        proFormaId: 0,
                        nodeId: 3403,
                        nodeName: 'Construction Loan - Holdback',
                        budgetLineNickname: 'Construction Loan - Holdback',
                        path: '3400.34019.3403',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3405,
                        proFormaId: 0,
                        nodeId: 3405,
                        nodeName: 'Construction Loan - Lender Administrative Fees',
                        budgetLineNickname: 'Construction Loan - Lender Administrative Fees',
                        path: '3400.34019.3405',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3406,
                        proFormaId: 0,
                        nodeId: 3406,
                        nodeName: 'Construction Loan - Miscellaneous Fees',
                        budgetLineNickname: 'Construction Loan - Miscellaneous Fees',
                        path: '3400.34019.3406',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3407,
                        proFormaId: 0,
                        nodeId: 3407,
                        nodeName: 'Construction Loan - Mortgage Broker Fee',
                        budgetLineNickname: 'Construction Loan - Mortgage Broker Fee',
                        path: '3400.34019.3407',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3408,
                        proFormaId: 0,
                        nodeId: 3408,
                        nodeName: 'Construction Loan - Mortgage Recording Tax',
                        budgetLineNickname: 'Construction Loan - Mortgage Recording Tax',
                        path: '3400.34019.3408',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3409,
                        proFormaId: 0,
                        nodeId: 3409,
                        nodeName: 'Construction Loan - Origination Fee',
                        budgetLineNickname: 'Construction Loan - Origination Fee',
                        path: '3400.34019.3409',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3410,
                        proFormaId: 0,
                        nodeId: 3410,
                        nodeName: 'Construction Loan - Title Fees',
                        budgetLineNickname: 'Construction Loan - Title Fees',
                        path: '3400.34019.3410',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3411,
                        proFormaId: 0,
                        nodeId: 3411,
                        nodeName: 'Escrow Fees',
                        budgetLineNickname: 'Escrow Fees',
                        path: '3400.34019.3411',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3412,
                        proFormaId: 0,
                        nodeId: 3412,
                        nodeName: 'Financing Contingency',
                        budgetLineNickname: 'Financing Contingency',
                        path: '3400.34019.3412',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 3413,
                        proFormaId: 0,
                        nodeId: 3413,
                        nodeName: 'Financing Fee',
                        budgetLineNickname: 'Financing fee',
                        path: '3400.34019.3413',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.FINANCING_FEE,
                        isCalculated: false,
                    },
                    {
                        id: 3414,
                        proFormaId: 0,
                        nodeId: 3414,
                        nodeName: 'Interest reserve',
                        budgetLineNickname: 'Interest reserve',
                        path: '3400.34019.3414',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.INTEREST_RESERVE,
                        isCalculated: true,
                    },
                ],
            }],
        },
        {
            id: 4400,
            proFormaId: 0,
            nodeId: 4400,
            nodeName: 'Soft Costs',
            description: 'Reserves',
            path: '4400',
            children: [{
                id: 4401,
                proFormaId: 0,
                nodeId: 4401,
                nodeName: 'Reserves',
                description: 'Reserves',
                path: '4400.4401',
                children: [
                    {
                        id: 4402,
                        proFormaId: 0,
                        nodeId: 4402,
                        nodeName: 'Operating Deficit',
                        budgetLineNickname: 'Operating Reserve',
                        path: '4400.4401.4402',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.OPERATING_RESERVE,
                        isCalculated: false,
                    },
                ],
            }],
        },
    ],
    totals: {
        amount: null,
        costPerGrossSquareFootage: null,
        costPerRentableSquareFootage: null,
        costPerLot: null,
        costPerResidentialUnit: null,
        costPerAcre: null,
        costPerMegawatt: null,
        costPerBed: null,
        costPerKilowatt: null,
        costPerRack: null,
    },
    periodsTotals: [],
};

export const INFRASTRUCTURE_AND_LAND_DEVELOPMENT_CATEGORIES = {
    uses: [
        {
            id: 2000,
            proFormaId: 0,
            nodeId: 2000,
            nodeName: 'Acquisition Costs',
            description: 'Acquisition Costs',
            path: '2000',
            children: [
                {
                    id: 2001,
                    proFormaId: 0,
                    nodeId: 2001,
                    nodeName: 'Acquisition',
                    description: 'Acquisition',
                    path: '2000.2001',
                    children: [
                        {
                            id: 2002,
                            proFormaId: 0,
                            nodeId: 2002,
                            nodeName: 'Acquisition Fees - Miscellaneous',
                            budgetLineNickname: 'Acquisition Fees - Miscellaneous',
                            path: '2000.2001.2002',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2003,
                            proFormaId: 0,
                            nodeId: 2003,
                            nodeName: 'Acquisition Loan - Interest',
                            budgetLineNickname: 'Acquisition Loan - Interest',
                            path: '2000.2001.2003',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2004,
                            proFormaId: 0,
                            nodeId: 2004,
                            nodeName: 'Acquisition Loan - Lender Administrative Fees',
                            budgetLineNickname: 'Acquisition Loan - Lender Administrative Fees',
                            path: '2000.2001.2004',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2005,
                            proFormaId: 0,
                            nodeId: 2005,
                            nodeName: 'Acquisition Loan - Miscellaneous Fees',
                            budgetLineNickname: 'Acquisition Loan - Miscellaneous Fees',
                            path: '2000.2001.2005',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2006,
                            proFormaId: 0,
                            nodeId: 2006,
                            nodeName: 'Acquisition Loan - Mortgage Broker Fee',
                            budgetLineNickname: 'Acquisition Loan - Mortgage Broker Fee',
                            path: '2000.2001.2006',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2007,
                            proFormaId: 0,
                            nodeId: 2007,
                            nodeName: 'Acquisition Loan - Title Fees',
                            budgetLineNickname: 'Acquisition Loan - Title Fees',
                            path: '2000.2001.2007',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2008,
                            proFormaId: 0,
                            nodeId: 2008,
                            nodeName: 'Purchase Price',
                            budgetLineNickname: 'Purchase Price',
                            path: '2000.2001.2008',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2009,
                            proFormaId: 0,
                            nodeId: 2009,
                            nodeName: 'Acquisition Due Diligence',
                            budgetLineNickname: 'Acquisition Due Diligence',
                            path: '2000.2001.2009',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 2100,
            proFormaId: 0,
            nodeId: 2100,
            nodeName: 'Hard Costs',
            description: 'Hard Costs',
            path: '2100',
            children: [
                {
                    id: 2101,
                    proFormaId: 0,
                    nodeId: 2101,
                    nodeName: 'Construction Manager',
                    description: 'Construction Manager',
                    path: '2100.2101',
                    children: [
                        {
                            id: 2102,
                            proFormaId: 0,
                            nodeId: 2102,
                            nodeName: 'Construction Manager (Overall including subcontractors)',
                            budgetLineNickname: 'Construction Manager (Overall including subcontractors)',
                            path: '2100.2101.2102',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2103,
                            proFormaId: 0,
                            nodeId: 2103,
                            nodeName: 'Contractor Contingency',
                            budgetLineNickname: 'Contractor Contingency',
                            path: '2100.2101.2103',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2104,
                            proFormaId: 0,
                            nodeId: 2104,
                            nodeName: 'General Contractor Fee',
                            budgetLineNickname: 'General Contractor Fee',
                            path: '2100.2101.2104',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2105,
                            proFormaId: 0,
                            nodeId: 2105,
                            nodeName: 'General Requirements',
                            budgetLineNickname: 'General Requirements',
                            path: '2100.2101.2105',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2106,
                            proFormaId: 0,
                            nodeId: 2106,
                            nodeName: 'Pre-Construction Fees',
                            budgetLineNickname: 'Pre-Construction Fees',
                            path: '2100.2101.2106',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2107,
                    proFormaId: 0,
                    nodeId: 2107,
                    nodeName: 'Owner Furnished',
                    description: 'Owner Furnished',
                    path: '2100.2107',
                    children: [
                        {
                            id: 2108,
                            proFormaId: 0,
                            nodeId: 2108,
                            nodeName: 'Earthwork - Earth Moving',
                            budgetLineNickname: 'Earthwork - Earth Moving',
                            path: '2100.2107.2108',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2109,
                            proFormaId: 0,
                            nodeId: 2109,
                            nodeName: 'Earthwork - Earthwork Methods',
                            budgetLineNickname: 'Earthwork - Earthwork Methods',
                            path: '2100.2107.2109',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2110,
                            proFormaId: 0,
                            nodeId: 2110,
                            nodeName: 'Earthwork - Excavation Support and Protection',
                            budgetLineNickname: 'Earthwork - Excavation Support and Protection',
                            path: '2100.2107.2110',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2111,
                            proFormaId: 0,
                            nodeId: 2111,
                            nodeName: 'Earthwork - Shoring and Underpinning',
                            budgetLineNickname: 'Earthwork - Shoring and Underpinning',
                            path: '2100.2107.2111',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2112,
                            proFormaId: 0,
                            nodeId: 2112,
                            nodeName: 'Earthwork - Site Clearing',
                            budgetLineNickname: 'Earthwork - Site Clearing',
                            path: '2100.2107.2112',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2113,
                            proFormaId: 0,
                            nodeId: 2113,
                            nodeName: 'Earthwork - Special Foundations and Load-Bearing Elements',
                            budgetLineNickname: 'Earthwork - Special Foundations and Load-Bearing Elements',
                            path: '2100.2107.2113',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2114,
                            proFormaId: 0,
                            nodeId: 2114,
                            nodeName: 'Existing Conditions - Contaminated Site Material Removal',
                            budgetLineNickname: 'Existing Conditions - Contaminated Site Material Removal',
                            path: '2100.2107.2114',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2115,
                            proFormaId: 0,
                            nodeId: 2115,
                            nodeName: 'Existing Conditions - Demolition and Structure Moving',
                            budgetLineNickname: 'Existing Conditions - Demolition and Structure Moving',
                            path: '2100.2107.2115',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2116,
                            proFormaId: 0,
                            nodeId: 2116,
                            nodeName: 'Existing Conditions - Site Remediation',
                            budgetLineNickname: 'Existing Conditions - Site Remediation',
                            path: '2100.2107.2116',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2117,
                            proFormaId: 0,
                            nodeId: 2117,
                            nodeName: 'Existing Conditions - Subsurface Investigation',
                            budgetLineNickname: 'Existing Conditions - Subsurface Investigation',
                            path: '2100.2107.2117',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2118,
                            proFormaId: 0,
                            nodeId: 2118,
                            nodeName: 'Existing Conditions - Water Remediation',
                            budgetLineNickname: 'Existing Conditions - Water Remediation',
                            path: '2100.2107.2118',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2119,
                            proFormaId: 0,
                            nodeId: 2119,
                            nodeName: 'Exterior Improvements - Bases, Ballasts, and Paving',
                            budgetLineNickname: 'Exterior Improvements - Bases, Ballasts, and Paving',
                            path: '2100.2107.2119',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2120,
                            proFormaId: 0,
                            nodeId: 2120,
                            nodeName: 'Exterior Improvements - Site Improvements',
                            budgetLineNickname: 'Exterior Improvements - Site Improvements',
                            path: '2100.2107.2120',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2121,
                            proFormaId: 0,
                            nodeId: 2121,
                            nodeName: 'Exterior Improvements - Wetlands, Irrigation, and Planting',
                            budgetLineNickname: 'Exterior Improvements - Wetlands, Irrigation, and Planting',
                            path: '2100.2107.2121',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2122,
                            proFormaId: 0,
                            nodeId: 2122,
                            nodeName: 'Pollution and Waste Control Equipment',
                            budgetLineNickname: 'Pollution and Waste Control Equipment',
                            path: '2100.2107.2122',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2123,
                            proFormaId: 0,
                            nodeId: 2123,
                            nodeName: 'Utilities - Communications Utilities',
                            budgetLineNickname: 'Utilities - Communications Utilities',
                            path: '2100.2107.2123',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2124,
                            proFormaId: 0,
                            nodeId: 2124,
                            nodeName: 'Utilities - Electrical Utilities',
                            budgetLineNickname: 'Utilities - Electrical Utilities',
                            path: '2100.2107.2124',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2125,
                            proFormaId: 0,
                            nodeId: 2125,
                            nodeName: 'Utilities - Sanitary Sewerage',
                            budgetLineNickname: 'Utilities - Sanitary Sewerage',
                            path: '2100.2107.2125',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2126,
                            proFormaId: 0,
                            nodeId: 2126,
                            nodeName: 'Utilities - Stormwater Utilities',
                            budgetLineNickname: 'Utilities - Stormwater Utilities',
                            path: '2100.2107.2126',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2127,
                            proFormaId: 0,
                            nodeId: 2127,
                            nodeName: 'Utilities - Water Utilities',
                            budgetLineNickname: 'Utilities - Water Utilities',
                            path: '2100.2107.2127',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2128,
                            proFormaId: 0,
                            nodeId: 2128,
                            nodeName: 'Utility Connection Charges',
                            budgetLineNickname: 'Utility Connection Charges',
                            path: '2100.2107.2128',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2129,
                            proFormaId: 0,
                            nodeId: 2129,
                            nodeName: 'Water and Wastewater Equipment',
                            budgetLineNickname: 'Water and Wastewater Equipment',
                            path: '2100.2107.2129',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2130,
                    proFormaId: 0,
                    nodeId: 2130,
                    nodeName: 'Owner Controlled Contingency',
                    description: 'Owner Controlled Contingency',
                    path: '2100.2130',
                    children: [
                        {
                            id: 2131,
                            proFormaId: 0,
                            nodeId: 2131,
                            nodeName: 'Allowances',
                            budgetLineNickname: 'Allowances',
                            path: '2100.2130.2131',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2132,
                            proFormaId: 0,
                            nodeId: 2132,
                            nodeName: 'Owner Controlled Contingency',
                            budgetLineNickname: 'Owner Controlled Contingency',
                            path: '2100.2130.2132',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 2200,
            proFormaId: 0,
            nodeId: 2200,
            nodeName: 'Soft Costs',
            description: 'Soft Costs',
            path: '2200',
            children: [
                {
                    id: 2201,
                    proFormaId: 0,
                    nodeId: 2201,
                    nodeName: 'Insurance, Utilities, Taxes & Other',
                    description: 'Insurance, Utilities, Taxes & Other',
                    path: '2200.2201',
                    children: [
                        {
                            id: 2202,
                            proFormaId: 0,
                            nodeId: 2202,
                            nodeName: 'Bond and Insurance',
                            budgetLineNickname: 'Bond and Insurance',
                            path: '2200.2201.2202',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2203,
                            proFormaId: 0,
                            nodeId: 2203,
                            nodeName: 'Insurance - Miscellaneous',
                            budgetLineNickname: 'Insurance - Miscellaneous',
                            path: '2200.2201.2203',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2204,
                            proFormaId: 0,
                            nodeId: 2204,
                            nodeName: 'Licenses and Operating Permits',
                            budgetLineNickname: 'Licenses and Operating Permits',
                            path: '2200.2201.2204',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2205,
                            proFormaId: 0,
                            nodeId: 2205,
                            nodeName: 'Real Estate Taxes',
                            budgetLineNickname: 'Real Estate Taxes',
                            path: '2200.2201.2205',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2206,
                            proFormaId: 0,
                            nodeId: 2206,
                            nodeName: 'Title Insurance',
                            budgetLineNickname: 'Title Insurance',
                            path: '2200.2201.2206',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2207,
                    proFormaId: 0,
                    nodeId: 2207,
                    nodeName: 'Architecture, Engineering, & Design',
                    description: 'Architecture, Engineering, & Design',
                    path: '2200.2207',
                    children: [
                        {
                            id: 2208,
                            proFormaId: 0,
                            nodeId: 2208,
                            nodeName: 'Civil Engineer',
                            budgetLineNickname: 'Civil Engineer',
                            path: '2200.2207.2208',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2209,
                            proFormaId: 0,
                            nodeId: 2209,
                            nodeName: 'Consultant Reimbursables',
                            budgetLineNickname: 'Consultant Reimbursables',
                            path: '2200.2207.2209',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2210,
                            proFormaId: 0,
                            nodeId: 2210,
                            nodeName: 'Geotechnical Design and Engineering',
                            budgetLineNickname: 'Geotechnical Design and Engineering',
                            path: '2200.2207.2210',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2211,
                            proFormaId: 0,
                            nodeId: 2211,
                            nodeName: 'Landscape Architect',
                            budgetLineNickname: 'Landscape Architect',
                            path: '2200.2207.2211',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2212,
                            proFormaId: 0,
                            nodeId: 2212,
                            nodeName: 'MEP Engineer',
                            budgetLineNickname: 'MEP Engineer',
                            path: '2200.2207.2212',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2213,
                            proFormaId: 0,
                            nodeId: 2213,
                            nodeName: 'Master Planning',
                            budgetLineNickname: 'Master Planning',
                            path: '2200.2207.2213',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2214,
                            proFormaId: 0,
                            nodeId: 2214,
                            nodeName: 'Project Architect',
                            budgetLineNickname: 'Project Architect',
                            path: '2200.2207.2214',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2215,
                            proFormaId: 0,
                            nodeId: 2215,
                            nodeName: 'Structural Engineer',
                            budgetLineNickname: 'Structural Engineer',
                            path: '2200.2207.2215',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2216,
                    proFormaId: 0,
                    nodeId: 2216,
                    nodeName: 'Other Consultants',
                    description: 'Other Consultants',
                    path: '2200.2216',
                    children: [
                        {
                            id: 2217,
                            proFormaId: 0,
                            nodeId: 2217,
                            nodeName: 'Abatement Consultant',
                            budgetLineNickname: 'Abatement Consultant',
                            path: '2200.2216.2217',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2218,
                            proFormaId: 0,
                            nodeId: 2218,
                            nodeName: 'Environmental Consultant',
                            budgetLineNickname: 'Environmental Consultant',
                            path: '2200.2216.2218',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2219,
                            proFormaId: 0,
                            nodeId: 2219,
                            nodeName: 'Site Logistics Engineer',
                            budgetLineNickname: 'Site Logistics Engineer',
                            path: '2200.2216.2219',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2220,
                            proFormaId: 0,
                            nodeId: 2220,
                            nodeName: 'Surveyor',
                            budgetLineNickname: 'Surveyor',
                            path: '2200.2216.2220',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2221,
                            proFormaId: 0,
                            nodeId: 2221,
                            nodeName: 'Sustainability Consultant',
                            budgetLineNickname: 'Sustainability Consultant',
                            path: '2200.2216.2221',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2222,
                            proFormaId: 0,
                            nodeId: 2222,
                            nodeName: 'Transportation and Traffic Consultant',
                            budgetLineNickname: 'Transportation and Traffic Consultant',
                            path: '2200.2216.2222',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2223,
                            proFormaId: 0,
                            nodeId: 2223,
                            nodeName: 'Utilities Consultant',
                            budgetLineNickname: 'Utilities Consultant',
                            path: '2200.2216.2223',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2224,
                    proFormaId: 0,
                    nodeId: 2224,
                    nodeName: 'General Administrative & Overhead',
                    description: 'General Administrative & Overhead',
                    path: '2200.2224',
                    children: [
                        {
                            id: 2225,
                            proFormaId: 0,
                            nodeId: 2225,
                            nodeName: 'Accounting and Audits',
                            budgetLineNickname: 'Accounting and Audits',
                            path: '2200.2224.2225',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2226,
                            proFormaId: 0,
                            nodeId: 2226,
                            nodeName: 'Building Permits',
                            budgetLineNickname: 'Building Permits',
                            path: '2200.2224.2226',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2227,
                            proFormaId: 0,
                            nodeId: 2227,
                            nodeName: 'Developer Fee',
                            budgetLineNickname: 'Developer Fee',
                            path: '2200.2224.2227',
                            isDeletable: false,
                            classificationType: BudgetClassificationTypeEnum.DEVELOPER_FEE,
                            isCalculated: false,
                        },
                        {
                            id: 2228,
                            proFormaId: 0,
                            nodeId: 2228,
                            nodeName: 'General Administration',
                            budgetLineNickname: 'General Administration',
                            path: '2200.2224.2228',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2229,
                            proFormaId: 0,
                            nodeId: 2229,
                            nodeName: 'Pollution Liability and Environmental Insurance',
                            budgetLineNickname: 'Pollution Liability and Environmental Insurance',
                            path: '2200.2224.2229',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2230,
                            proFormaId: 0,
                            nodeId: 2230,
                            nodeName: 'Project Management',
                            budgetLineNickname: 'Project Management',
                            path: '2200.2224.2230',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2231,
                            proFormaId: 0,
                            nodeId: 2231,
                            nodeName: 'Project Software and Applications',
                            budgetLineNickname: 'Project Software and Applications',
                            path: '2200.2224.2231',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2232,
                            proFormaId: 0,
                            nodeId: 2232,
                            nodeName: 'Site Security and Maintenance',
                            budgetLineNickname: 'Site Security and Maintenance',
                            path: '2200.2224.2232',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2233,
                            proFormaId: 0,
                            nodeId: 2233,
                            nodeName: 'Sponsor Reimbursables',
                            budgetLineNickname: 'Sponsor Reimbursables',
                            path: '2200.2224.2233',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2234,
                            proFormaId: 0,
                            nodeId: 2234,
                            nodeName: 'Utilities During Construction',
                            budgetLineNickname: 'Utilities During Construction',
                            path: '2200.2224.2234',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2235,
                    proFormaId: 0,
                    nodeId: 2235,
                    nodeName: 'Expediting, Inspections & Approvals',
                    description: 'Expediting, Inspections & Approvals',
                    path: '2200.2235',
                    children: [
                        {
                            id: 2236,
                            proFormaId: 0,
                            nodeId: 2236,
                            nodeName: 'Construction Surveys and Monitoring',
                            budgetLineNickname: 'Construction Surveys and Monitoring',
                            path: '2200.2235.2236',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2237,
                            proFormaId: 0,
                            nodeId: 2237,
                            nodeName: 'Entitlements Consultant',
                            budgetLineNickname: 'Entitlements Consultant',
                            path: '2200.2235.2237',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2238,
                            proFormaId: 0,
                            nodeId: 2238,
                            nodeName: 'Environmental Testing',
                            budgetLineNickname: 'Environmental Testing',
                            path: '2200.2235.2238',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2239,
                            proFormaId: 0,
                            nodeId: 2239,
                            nodeName: 'Impact Review and Mitigation Fees',
                            budgetLineNickname: 'Impact Review and Mitigation Fees',
                            path: '2200.2235.2239',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2240,
                            proFormaId: 0,
                            nodeId: 2240,
                            nodeName: 'Permits and Fees - Miscellaneous',
                            budgetLineNickname: 'Permits and Fees - Miscellaneous',
                            path: '2200.2235.2240',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2241,
                            proFormaId: 0,
                            nodeId: 2241,
                            nodeName: 'Special and Controlled Inspections',
                            budgetLineNickname: 'Special and Controlled Inspections',
                            path: '2200.2235.2241',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2242,
                            proFormaId: 0,
                            nodeId: 2242,
                            nodeName: 'Stormwater Pollution Plan and Monitoring',
                            budgetLineNickname: 'Stormwater Pollution Plan and Monitoring',
                            path: '2200.2235.2242',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2243,
                    proFormaId: 0,
                    nodeId: 2243,
                    nodeName: 'Legal Services',
                    description: 'Legal Services',
                    path: '2200.2243',
                    children: [
                        {
                            id: 2244,
                            proFormaId: 0,
                            nodeId: 2244,
                            nodeName: 'Legal Services',
                            budgetLineNickname: 'Legal Services',
                            path: '2200.2243.2244',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2245,
                            proFormaId: 0,
                            nodeId: 2245,
                            nodeName: 'Land Use and Zoning',
                            budgetLineNickname: 'Land Use and Zoning',
                            path: '2200.2243.2245',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2246,
                    proFormaId: 0,
                    nodeId: 2246,
                    nodeName: 'Contingency',
                    description: 'Contingency',
                    path: '2200.2246',
                    children: [
                        {
                            id: 2247,
                            proFormaId: 0,
                            nodeId: 2247,
                            nodeName: 'Soft Cost Contingency',
                            budgetLineNickname: 'Soft Cost Contingency',
                            path: '2200.2246.2247',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
                {
                    id: 2252,
                    proFormaId: 0,
                    nodeId: 2252,
                    nodeName: 'Marketing',
                    description: 'Marketing',
                    path: '2200.2252',
                    children: [
                        {
                            id: 2253,
                            proFormaId: 0,
                            nodeId: 2253,
                            nodeName: 'Marketing (general)',
                            budgetLineNickname: 'Marketing (general)',
                            path: '2200.2252.2253',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2254,
                            proFormaId: 0,
                            nodeId: 2254,
                            nodeName: 'Digital Marketing',
                            budgetLineNickname: 'Digital Marketing',
                            path: '2200.2252.2254',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2255,
                            proFormaId: 0,
                            nodeId: 2255,
                            nodeName: 'Marketing Collateral',
                            budgetLineNickname: 'Marketing Collateral',
                            path: '2200.2252.2255',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2256,
                            proFormaId: 0,
                            nodeId: 2256,
                            nodeName: 'Marketing Signage',
                            budgetLineNickname: 'Marketing Signage',
                            path: '2200.2252.2256',
                            isDeletable: true,
                            isCalculated: false,
                        },
                        {
                            id: 2257,
                            proFormaId: 0,
                            nodeId: 2257,
                            nodeName: 'Public Relations',
                            budgetLineNickname: 'Public Relations',
                            path: '2200.2252.2257',
                            isDeletable: true,
                            isCalculated: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 2300,
            proFormaId: 0,
            nodeId: 2300,
            nodeName: 'Soft Costs',
            description: 'Financing Costs',
            path: '2300',
            children: [{
                id: 2301,
                proFormaId: 0,
                nodeId: 2301,
                nodeName: 'Soft Costs',
                description: 'Financing Costs',
                path: '2300.2301',
                children: [
                    {
                        id: 2249,
                        proFormaId: 0,
                        nodeId: 2249,
                        nodeName: 'Escrow Fees',
                        budgetLineNickname: 'Escrow Fees',
                        path: '2300.2301.2249',
                        isDeletable: true,
                        isCalculated: false,
                    },
                    {
                        id: 2250,
                        proFormaId: 0,
                        nodeId: 2250,
                        nodeName: 'Financing Fee',
                        budgetLineNickname: 'Financing fee',
                        path: '2300.2301.2250',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.FINANCING_FEE,
                        isCalculated: false,
                    },
                    {
                        id: 2251,
                        proFormaId: 0,
                        nodeId: 2251,
                        nodeName: 'Interest reserve',
                        budgetLineNickname: 'Interest reserve',
                        path: '2300.2301.2251',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.INTEREST_RESERVE,
                        isCalculated: true,
                    },
                ],
            }],
        },
        {
            id: 4400,
            proFormaId: 0,
            nodeId: 4400,
            nodeName: 'Soft Costs',
            description: 'Reserves',
            path: '4400',
            children: [{
                id: 4401,
                proFormaId: 0,
                nodeId: 4401,
                nodeName: 'Reserves',
                description: 'Reserves',
                path: '4400.4401',
                children: [
                    {
                        id: 4402,
                        proFormaId: 0,
                        nodeId: 4402,
                        nodeName: 'Operating Deficit',
                        budgetLineNickname: 'Operating Reserve',
                        path: '4400.4401.4402',
                        isDeletable: false,
                        classificationType: BudgetClassificationTypeEnum.OPERATING_RESERVE,
                        isCalculated: true,
                    },
                ],
            }],
        },
    ],
    totals: {
        amount: null,
        costPerGrossSquareFootage: null,
        costPerRentableSquareFootage: null,
        costPerLot: null,
        costPerResidentialUnit: null,
        costPerAcre: null,
        costPerMegawatt: null,
        costPerBed: null,
        costPerKilowatt: null,
        costPerRack: null,
    },
    periodsTotals: [],
};

export const RECOMMENDED_CATEGORIES_PREVIEW_DATA: Record<string, any> = {
    'Ground Up': GROUND_UP_CATEGORIES,
    'Major Renovation': MAJOR_RENOVATION_CATEGORIES,
    'Infrastructure and Land Development': INFRASTRUCTURE_AND_LAND_DEVELOPMENT_CATEGORIES,
};

const generateExpandedState = (categories: any) => {
    const highLevels: number[] = [];
    const subcategories: number[] = [];

    categories.uses.map((highLevel: any) => {
        highLevels.push(highLevel.id);
        highLevel.children.map((subcategory: any) => {
            subcategories.push(subcategory.id);
            return null;
        });
        return null;
    });

    return { highLevels, subcategories };
};

export const RECOMMENDED_CATEGORIES_EXPANDED_STATE: Record<string, { highLevels: number[]; subcategories: number[] }> = {
    'Ground Up': generateExpandedState(GROUND_UP_CATEGORIES),
    'Major Renovation': generateExpandedState(MAJOR_RENOVATION_CATEGORIES),
    'Infrastructure and Land Development': generateExpandedState(INFRASTRUCTURE_AND_LAND_DEVELOPMENT_CATEGORIES),
};
